import React, { useContext, useMemo, useState } from 'react';
import Button from '../../../../components/bootstrap/Button';
import Card, { CardBody, CardHeader, CardLabel, CardTitle } from '../../../../components/bootstrap/Card';
import FormGroup from '../../../../components/bootstrap/forms/FormGroup';
import Input from '../../../../components/bootstrap/forms/Input';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import SelectStore from '../../../../components/MyCustom/SelectStore';
import { DefaultContext } from '../../../../contexts/default';
import PreAlert from '../../../../helpers/utils/preAlert';
import useDarkMode from '../../../../hooks/useDarkMode';
import Page from '../../../../layout/Page/Page';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import { demoPages, publicPages } from '../../../../menu';

const PreRegister = () => {
  const { darkModeStatus } = useDarkMode();
  const { estabSelected, storeSelected, store, onShowAlert } = useContext(DefaultContext);
  const [copied, setCopied] = useState(false);

  const publicLink = useMemo(() => {
    if (!estabSelected) return '';

    const params = new URLSearchParams();
    params.set('estabId', estabSelected);
    if (storeSelected) params.set('storeId', storeSelected);
    if (store?.image_url) {
      params.set('bannerUrl', store.image_url);
    }

    return `${window.location.origin}${publicPages.clientRegister.path}?${params.toString()}`;
  }, [estabSelected, storeSelected, store]);

  const handleCopy = async () => {
    if (!publicLink) return;

    try {
      await navigator.clipboard.writeText(publicLink);
      setCopied(true);
      onShowAlert(PreAlert.success('Link copiado com sucesso'));
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      onShowAlert(PreAlert.error('Não foi possível copiar o link'));
    }
  };

  return (
    <PageWrapper title={demoPages.pdvMenu.subMenu.preRegister.text}>
      <Page>
        <div className='column'>
          <SelectEstablishment />
          <SelectStore />
        </div>

        <div className='row pt-4'>
          <div className='col-12 col-xl-8'>
            <Card>
              <CardHeader>
                <CardLabel icon='PersonAdd' iconColor={darkModeStatus ? 'light' : 'dark'}>
                  <CardTitle>Página pública de pré-cadastro</CardTitle>
                </CardLabel>
              </CardHeader>
              <CardBody className='d-grid gap-4'>
                <p className='mb-0 text-muted'>
                  Use este link para abrir a página externa de pré-cadastro do cliente com estabelecimento e loja já definidos.
                </p>

                <FormGroup id='pre-register-link' label='Link público' className='mb-0'>
                  <Input value={publicLink} readOnly />
                </FormGroup>

                <div className='d-flex gap-2 flex-wrap'>
                  <Button
                    color='primary'
                    icon='ContentCopy'
                    onClick={handleCopy}
                    isDisable={!publicLink}>
                    {copied ? 'Link copiado' : 'Copiar link'}
                  </Button>
                  <Button
                    tag='a'
                    href={publicLink || undefined}
                    target='_blank'
                    color='success'
                    icon='OpenInNew'
                    isDisable={!publicLink}>
                    Abrir página
                  </Button>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </Page>
    </PageWrapper>
  );
};

export default PreRegister;
